import axios from "axios";
import { ENDPOINT } from "../utils/api";

const submitContact = async (
  name: string,
  email: string,
  subject: string,
  message: string
): Promise<boolean> => {
  const form = new FormData();

  // Contact Form 7 metadata
  form.append("_wpcf7", "38");
  form.append("_wpcf7_unit_tag", "wpcf7-f38-o1");

  // Contact form fields
  form.append("your-name", name);
  form.append("your-email", email);
  form.append("your-subject", subject);
  form.append("your-message", message);

  const response = await axios.post(
    `${ENDPOINT}/contact-form-7/v1/contact-forms/38/feedback`,
    form
  );

  console.log("Contact Form 7 response:", response.data);

  // CF7 can return HTTP 200 even when email delivery fails.
  if (response.data.status !== "mail_sent") {
    throw new Error(
      response.data.message || "Contact form submission failed"
    );
  }

  return true;
};

export default submitContact;